module.exports = __webpack_public_path__ + "img/AppointmentTypes.65c1255f.svg";